import { ScopeThreeSection } from "models/ScopeThreeCategoryOne/ScopeThreeCategoryOne.model";
import { alias, list, object, primitive, serializable } from "serializr";


export class FarmboxRawMaterials extends ScopeThreeSection {

    @serializable(alias('multi_origin', primitive()))
    multiOrigin?: boolean = false;

}

export class FarmboxRawMaterialsData {

    @serializable(list(object(FarmboxRawMaterials)))
    fertilizers?: FarmboxRawMaterials[] = [new FarmboxRawMaterials()];

    @serializable(list(object(FarmboxRawMaterials)))
    packagings?: FarmboxRawMaterials[] = [];

}

